var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeciality13(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c,.d{fill:none;stroke:#208ce1;stroke-linecap:round;stroke-width:1.5px;}.d{stroke-linejoin:round;}.e{fill:#e2e8f3;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 50,
    transform: "translate(-990 -7932)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(990 7932)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.175 -0.414)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-958.622-7912.767s.147,5.254-3.127,7.9c-2.62,2.125-8.52,1.217-9.654-2.112-2.338-6.863-1.508-15.084-8.824-11.615s-8.768,26.733.689,32.709"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-977.436-7885.1s3.945.29,5.743-6.266,11.777-5.105,13.866.638,6.44,5.859,8.412,3.133"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-957.653-7915.617s3.191-7.426,7.948-1.8,6.208,20.6,2.089,27.441"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-969.366-7883.143v-11.388"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-969.366-7883.143s.038-9.479-.308-10.969a6.471,6.471,0,0,0-.972-2.7c-.48-.9-1.284-2.5-2.049-4.333-1.579-3.776-1.888-6.248.858-7.552s5.321,2.025,4.737,7.209-3.259,5.011-3.259,5.011",
    transform: "translate(0 -21.605)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-971.544-7883.143s-.038-9.479.308-10.969a6.471,6.471,0,0,1,.972-2.7c.48-.9,1.284-2.5,2.049-4.333,1.579-3.776,1.888-6.248-.858-7.552s-5.321,2.025-4.737,7.209,3.259,5.011,3.259,5.011",
    transform: "translate(8.894 -21.605)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-963.987-7892.012v4.75",
    transform: "translate(2 -2.519)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-963.987-7892.012v3.244",
    transform: "translate(2 5.625)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-979.18-7914.523s-4.314,4.51-3.235,13.432"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-982.589-7914.523s3.094,2.6,2.9,8.581",
    transform: "translate(31.161)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-973.141-7906.756a13,13,0,0,0,7.185,4.641c2.686.533,6.528-.515,9.907-5.177-.625,4.552-4.331,8.206-10.48,6.988S-973.141-7906.756-973.141-7906.756Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeciality13);
export default __webpack_public_path__ + "static/media/speciality13.0af3c3447418a95b86ae127cda55fc1d.svg";
export { ForwardRef as ReactComponent };